import { HighlightBadgeContainer } from "@components/common/HighlightBadge";
import PremiumFeatureGate from "@components/common/premium/PremiumFeatureGate";
import { DSButton } from "@components/design-system/molecules";
import { faWindowRestore } from "@fortawesome/pro-solid-svg-icons";
import { useLocalStorage } from "@hooks";
import { Tooltip } from "@mui/material";

export const OpenPipButton = ({ pipUrl, isBadgeEnabled = true }) => {
  const [hasEverOpenedPip, setHasEverOpenedPip] = useLocalStorage(
    "has-ever-opened-pip",
    false,
  );

  const onClick = async () => {
    // Only dismiss the badge if it was already enabled (i.e. avoid dismissing it if the user couldn't see it in the first place)
    if (isBadgeEnabled) {
      setHasEverOpenedPip(true);
    }

    // Open a window that only contains an <iframe>, and point the iframe to the pipUrl
    const pipWindow =
      await window.documentPictureInPicture.requestWindow({
        disallowReturnToOpener: true,
        width: 320,
        height: 600,
      });

    const styleNode = pipWindow.document.createElement("style");
    styleNode.innerHTML = `
      html, body, iframe {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
      }
      iframe {
        display: block;
        border: none;
      }
    `;
    pipWindow.document.head.appendChild(styleNode);

    const iframe = document.createElement("iframe");
    iframe.src = pipUrl;
    pipWindow.document.body.appendChild(iframe);

    iframe.contentWindow.addEventListener(
      "message",
      (evt) => {
        if (evt.data.returnToTab) {
          window.focus();
          pipWindow.close();
        }
      },
      false,
    );
  };

  if (!window.documentPictureInPicture) {
    return null;
  }

  return (
    <PremiumFeatureGate
      featureName="Widget Mode"
      iconPosition="top-right"
      iconSize="sm"
    >
      <Tooltip
        arrow
        placement="bottom"
        title="Widget Mode allows you to access Scribenote features more easily side-by-side with your PIMS/medical records."
      >
        <div className="relative">
          <HighlightBadgeContainer
            isBadgeVisible={!hasEverOpenedPip && isBadgeEnabled}
          >
            <DSButton
              variant="secondary"
              size="sm"
              icon={faWindowRestore}
              onClick={onClick}
              data-mx-label="pip-open"
              dataTestId="pip-open-button"
            >
              Widget Mode
            </DSButton>
          </HighlightBadgeContainer>
        </div>
      </Tooltip>
    </PremiumFeatureGate>
  );
};
